import { render, staticRenderFns } from "./UploadedImages.vue?vue&type=template&id=133cb9c4&lang=true&"
import script from "./UploadedImages.vue?vue&type=script&lang=js&"
export * from "./UploadedImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports